import React, { useState } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { loginSecretary } from "../../services/Secretary_service";
import '../../css/login.css';
import logo from '../../image/logo_alo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useNavigate } from 'react-router-dom';
import { useForm, SubmitHandler } from "react-hook-form";
import { faLock, faEye, faEyeSlash, faEnvelope } from '@fortawesome/free-solid-svg-icons';

type Inputs = {
    email: string;
    password: string;
};

const SecretaryLogin: React.FC = () => {
    const { register, handleSubmit, formState: { errors }, reset } = useForm<Inputs>();
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState<boolean>(false);

    const onSubmit: SubmitHandler<Inputs> = async (data: Inputs) => {
        try {
            setLoading(true);
            localStorage.clear();
            
            const response = await loginSecretary(data.email, data.password);

            if (response && response.secretary) {
                toast.success("Connexion réussie !");
                setTimeout(() => {
                    navigate("/secretary-dashboard");
                }, 800);
            }
        } catch (error: any) {
            console.error("Erreur de connexion secrétaire:", error);
            
            if (error?.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Email ou mot de passe incorrect");
            }
        } finally {
            setLoading(false);
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <>
            <ToastContainer />
            <div className="degrade-vertical big-height">
                <div className="row col-section d-flex justify-content-center align-items-center">
                    <div className="col-12 col-md-6 col-lg-6 d-flex bg-dark-login section-txt">
                        <div className="p-3 logo">
                            <img src={logo} className="my-2 ml-3 logo-1" alt="logo" />
                        </div>

                        <form className="form-login pb-4 px-5 pt-4 d-flex" onSubmit={handleSubmit(onSubmit)}>
                            <p className="txt-login mb-4">Connexion Assistant</p>

                            <div className="col-md-13 col-12">
                                <div className="input-group mb-3">
                                    <span className="input-group-text" id="basic-addon1">
                                        <FontAwesomeIcon icon={faEnvelope} />
                                    </span>
                                    <input
                                        type="email"
                                        className="form-control"
                                        placeholder="Email"
                                        {...register('email', {
                                            required: 'Email est requis'
                                        })}
                                    />
                                </div>
                                {errors.email && <p className="error-message">{errors.email.message}</p>}
                            </div>

                            <div className="col-md-13 col-12">
                                <div className="input-group">
                                    <span className="input-group-text" id="basic-addon1">
                                        <FontAwesomeIcon icon={faLock} />
                                    </span>
                                    <input
                                        className="form-control"
                                        type={showPassword ? "text" : "password"}
                                        placeholder="Mot de passe"
                                        {...register('password', { required: 'Mot de passe est requis' })}
                                    />
                                    <button
                                        className="btn btn-outline-secondary"
                                        type='button'
                                        onClick={togglePasswordVisibility}
                                        aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                                    >
                                        <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                                    </button>
                                </div>
                                {errors.password && <p className="error-message">{errors.password.message}</p>}
                            </div>

                            <button type="submit" className="btn btn-1 mt-4" disabled={loading}>
                                {loading ? "Connexion..." : "Se connecter"}
                            </button>

                            <div className="my-3">
                                <p>Vous êtes un client ?
                                    <Link to="/login" className="txt-orange mx-1">Se connecter ici</Link>
                                </p>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SecretaryLogin;